import React, { useState } from "react";
import axios from "axios";
import { Check, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ADD_NEW = "__add_new__";

export const CaseManagerSelect = ({ value, options, onChange, onOptionsChange, testId }) => {
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSelect = (e) => {
    const v = e.target.value;
    if (v === ADD_NEW) {
      setAdding(true);
      return;
    }
    onChange(v || null);
  };

  const confirmAdd = async () => {
    const name = newName.trim();
    if (!name) {
      setAdding(false);
      return;
    }
    setSaving(true);
    try {
      const res = await axios.post(`${API}/case-managers`, { name }, { withCredentials: true });
      onOptionsChange(res.data);
      onChange(name);
    } finally {
      setSaving(false);
      setAdding(false);
      setNewName("");
    }
  };

  if (adding) {
    return (
      <div className="flex items-center gap-1">
        <input
          autoFocus
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && confirmAdd()}
          placeholder="New name…"
          data-testid={`${testId}-new-input`}
          className="w-28 rounded-full border border-[#E5E7EB] px-2.5 py-1 text-xs outline-none focus:border-[#052F24]/40"
        />
        <button
          type="button"
          onClick={confirmAdd}
          disabled={saving}
          data-testid={`${testId}-confirm-btn`}
          className="text-[#052F24] hover:opacity-70 disabled:opacity-40"
        >
          <Check size={14} />
        </button>
        <button
          type="button"
          onClick={() => { setAdding(false); setNewName(""); }}
          data-testid={`${testId}-cancel-btn`}
          className="text-[#9CA3AF] hover:text-[#052F24]"
        >
          <X size={14} />
        </button>
      </div>
    );
  }

  return (
    <select
      value={value || ""}
      onChange={handleSelect}
      data-testid={testId}
      className="rounded-full px-3 py-1.5 text-xs font-bold border-0 outline-none cursor-pointer bg-[#F3F4F6] text-[#052F24]"
    >
      <option value="">Unassigned</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
      <option value={ADD_NEW}>+ Add new…</option>
    </select>
  );
};
